import { cn } from "../../primitives/utils";

/**
 * How one part's artwork should be supplied: the server's sentence ("32
 * single pages, 148 × 210 mm, in reading order…") and its short extra points,
 * so staff can answer "how do you want the artwork?" from the order. Nothing
 * when it is not known (a manual line, a line with no configuration). The
 * words are the read's; nothing here assembles them.
 */
export function SupplyGuide({
  sentence,
  notes,
  className,
}: {
  sentence?: string | null;
  notes?: string[];
  className?: string;
}) {
  if (!sentence) return null;
  return (
    <div className={cn("space-y-1 text-xs text-muted-foreground", className)}>
      <p>
        <span className="font-medium text-foreground">How to supply: </span>
        {sentence}
      </p>
      {notes && notes.length > 0 && (
        <ul className="list-disc space-y-0.5 pl-5">
          {notes.map((note) => (
            <li key={note}>{note}</li>
          ))}
        </ul>
      )}
    </div>
  );
}
